/**
 * Visualization-specific utility functions.
 *
 * Enums, formatters, and color utilities now live in @atlas-int/data.
 * Import them from there directly. This file only contains
 * app-specific functions that depend on local routing/context.
 */

import { ProductClass } from "@atlas-int/data/types";

// Re-export enums for the few remaining barrel consumers (controls).
// New code should import from @atlas-int/data/types directly.
export {
  VizType,
  UIView,
  LocationDetailLevel,
  ProductClass,
  ServicesClass,
  ProductLevel,
  TradeDirection,
  TradeFlow,
  ColorBy,
  LegendLabels,
  TradeDirectionSelectorString,
  VizClassification,
  MetadataMergeType,
} from "@atlas-int/data/types";

// ── Local utility functions ──────────────────────────────────────

export const defaultVizType = VizType.Tree;

const productClassValues = new Set<string>(Object.values(ProductClass));
export function toProductClass(value: string): ProductClass {
  if (productClassValues.has(value)) {
    return value as ProductClass;
  }
  console.warn(`[toProductClass] Unknown product class value: "${value}", defaulting to HS92`);
  return ProductClass.HS92Products;
}

import { overlayPortalContainerId as _overlayPortalContainerId } from "@atlas-int/data";
import { MetadataMergeType, VizClassification, VizType } from "@atlas-int/data";
export const overlayPortalContainerId = _overlayPortalContainerId;

const overlayPortalZIndex = 3000;

export const OverlayPortal = () => (
  <div
    id={overlayPortalContainerId}
    style={{
      position: "relative",
      zIndex: overlayPortalZIndex,
      pointerEvents: "all",
    }}
    tabIndex={-1}
  />
);

export const getVizClassification = ({ vizType }: { vizType: VizType }) => {
  if (vizType === VizType.Feasibility || vizType === VizType.ProductSpace) {
    return VizClassification.Complexity;
  }
  return VizClassification.Trade;
};
